export default "__VITE_ASSET__BfnQ6gh1__"